import React, {useState} from 'react';
import {applicationImport} from "../../apis/admin";
import {Button, Drawer, Form, message, Select, Tag, Upload} from "antd";
import {PlusOutlined, UploadOutlined, PaperClipOutlined} from '@ant-design/icons';
import './batchImportResult.scss'

function BatchImportResult(props) {
    const {pid, sectionIdOption} = props
    const [uploadFile, setUploadFile] = useState({uploading: false, fileList: []});
    const [uploadAttach, setUploadAttach] = useState({uploading: false, fileList: []});
    const [isOpenedDrawer, setIsOpenedDrawer] = useState(false);
    const [form] = Form.useForm()
    const {Option} = Select

    const importApplication = async () => {
        const sectionId = form.getFieldValue('sectionId')

        if(sectionId){
            setUploadFile({...uploadFile, uploading: true})
            setUploadAttach({...uploadAttach, uploading: true})
            try {
                const res = await applicationImport(pid, sectionId, uploadFile.fileList[0], uploadAttach.fileList[0]);
                if (res && res.error) {
                    throw new Error(`${res.error.msgCode} - ${res.error.message}`);
                } else {
                    message.success('上傳成功');
                }
            } catch(e){
                console.log(e)

                message.error('上傳失敗，請重新再試');
            }finally{
                setUploadFile({...uploadFile, uploading: false})
                setUploadAttach({...uploadAttach, uploading: false})
            }
        }
    }
    const showDrawer = () => {
        setIsOpenedDrawer(true)
    };

    const onClose = () => {
        setIsOpenedDrawer(false)
    };
    return (
        <div>
            <Button onClick={showDrawer}>
                <PlusOutlined /> 批量上傳結果
            </Button>
            <Drawer
                className='batch-upload-result'
                title="批量上傳結果"
                width={284}
                onClose={onClose}
                visible={isOpenedDrawer}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Tag color='default'>請選擇上傳項目</Tag>
                <Form
                    hideRequiredMark={true}
                    className='import-bar'
                    form={form}
                >
                    <Form.Item
                        name='sectionId'
                        rules={[{ required: true, message: '請選擇項目' }]}
                    >
                        <Select
                            placeholder='上傳項目'
                        >
                            {
                                Object.keys(sectionIdOption.importResult).map((id, i) => {
                                    return (
                                        <Option
                                            key={i}
                                            value={id}
                                        >
                                            {sectionIdOption.importResult[id]}
                                        </Option>
                                    )
                                })
                            }
                        </Select>
                    </Form.Item>

                    <div className='flex-container'>
                        <Upload
                            className='uploader'

                            multiple={false}
                            accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            showUploadList={
                                {
                                    showPreviewIcon: false,
                                    showRemoveIcon: false,
                                    showDownloadIcon: false
                                }
                            }
                            beforeUpload={file => {
                                setUploadFile({...uploadFile, fileList: [file]})
                                return false;
                            }}
                            fileList={uploadFile.fileList}
                        >
                            <Tag color='default'>選取檔案 (.xlsx)</Tag>
                            <Button>
                                <UploadOutlined /> 選取檔案
                            </Button>
                        </Upload>
                        <Upload
                            className='uploader'
                            multiple={false}
                            accept='application/zip'
                            showUploadList={
                                {
                                    showPreviewIcon: false,
                                    showRemoveIcon: false,
                                    showDownloadIcon: false
                                }
                            }

                            beforeUpload={file => {
                                setUploadAttach({...uploadAttach, fileList: [file]})
                                return false;
                            }}
                            fileList={uploadAttach.fileList}
                        >
                            <Tag color='default'>如有附件 (.zip)</Tag>
                            <Button>
                                <PaperClipOutlined /> 選取附件
                            </Button>
                        </Upload>
                        <Form.Item>
                            <Button
                                htmlType='submit'
                                onClick={() => importApplication()}
                                disabled={uploadFile.fileList.length === 0}
                                loading={uploadFile.uploading || uploadAttach.uploading}
                            >
                                {(uploadFile.uploading || uploadAttach.uploading )? '上傳中' : '上傳檔案'}
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
            </Drawer>
        </div>
    );
}

export default BatchImportResult;
